/* eslint-disable */
export const parseUserAgent = function (userAgentString) {
  const browsers = [
    [ 'edge', /Edge\/([0-9\._]+)/ ],
    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
    // detect IE11
    [ 'ie', /Trident\/7\.0.+rv.([\d\.]+).*Gecko$/ ],
    // detect older IE
    [ 'ie', /MSIE\s([\d\.]+)/ ],
    [ 'ie', /MSIE\s(7\.0)/ ],
    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
    [ 'android', /Android\s([0-9\.]+)/ ],
    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
  ]

  return browsers.map(rule => {
    if (rule[1].test(userAgentString)) {
      const match = rule[1].exec(userAgentString)
      const version = match && match[1].split(/[._]/).slice(0, 3)

      if (version.length < 3) {
        version.length = 3
        version.fill(0, 2)
      }

      return {
        name: rule[0],
        version: version.join('.'),
      }
    }
  }).filter(Boolean).shift()
}

export const getBrowserInfo = () => {
  const browser = parseUserAgent(navigator.userAgent)
  return browser
}

export const CheckForOutdatedBrowser = () => {
  const browser = getBrowserInfo()

  const browserDict = {
    chrome: {
      lowestVersion: 32,
    },
    edge: {
      lowestVersion: 12,
    },
    firefox: {
      lowestVersion: 21,
    },
    ie: {
      lowestVersion: 10,
    },
    ios: {
      lowestVersion: 8,
    },
    safari: {
      lowestVersion: 7,
    },
  }

  if (!browser) {
    return true
  }
  const name = browser.name
  const version = Number.parseInt(browser.version, 10)

  if (!browserDict[name]) {
    return true
  }

  if (version < browserDict[name].lowestVersion) {
    return true
  }
  return false
}

export default CheckForOutdatedBrowser



// WEBPACK FOOTER //
// ./src/legacy/containers/CheckForOutdatedBrowser/CheckForOutdatedBrowser.js